var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tenantManager)?_c('organizational',{attrs:{"nest":true}}):_c('OrgAndNumber',{attrs:{"module":"user"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }